import { useContext } from 'react';

import './context';
import { VBaseCheckboxRadioGroupContext } from './context';
import type { VBaseCheckboxRadioGroupContextValue } from './type';

export const useBaseCheckboxRadioGroup = <
  M extends boolean,
  U = M extends true ? string[] : string,
>() =>
  useContext(
    VBaseCheckboxRadioGroupContext,
  ) as VBaseCheckboxRadioGroupContextValue<M, U>;
